import useSetOnlineStatus from './useSetOnlineStatus';

export default function UseSetOnlineStatusGlobal() {
  useSetOnlineStatus();
  return null;
} 